import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';

const classes = {
  paper: {
    maxWidth: '436px',
    width: '100%',
  },
  title: {
    padding: '21px 24px 16px 24px',
    '&& h2': {
      color: '#212322',
      fontSize: '20px',

    },
  },
  body: {
    padding: '0 24px 16px 24px',
    '&& p': {
      color: 'rgba(33,35,34,0.5)',
      fontSize: '13px',
    },
  },
  actions: {
    margin: '0',
    padding: '12px 24px 14px 24px',
    borderTop: '2px solid #EDEDED;',
    '&& button': {
      fontSize: '14px',
      padding: '8px 13px',
    },
  },
};

const ConfirmationModal = ({ message, classes, cancelText, okText, open, onCancel, onOk, title, children, loading }) => {
  return (
    <Dialog
      open={open}
      scroll="paper"
      classes={{ paper: classes.paper }}
    >
      {title && <DialogTitle className={classes.title}>{title}</DialogTitle>}
      {(children || message) && <DialogContent className={classes.body}>
        {children || <DialogContentText id="alert-dialog-description" variant="body2">
          {message}
        </DialogContentText>}
      </DialogContent>}
      <DialogActions className={classes.actions}>
        <Button
          onClick={onCancel}
          variant="outlined"
          disabled={loading}
          data-testid="dialog-prompt-cancel-button"
        >
          {cancelText}
        </Button>
        <Button
          onClick={onOk}
          variant="contained"
          color="secondary"
          disabled={loading}
          data-testid="dialog-prompt-ok-button"
        >
          {loading && <CircularProgress size={25} thickness={2}/>}
          {okText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(classes)(ConfirmationModal);
